export default __webpack_public_path__ + "static/scores@mob-aa0a5634c38688f0a568411a26e35f79.webp";